import { combineReducers } from "redux";

import { commonReducer } from "./commonReducer";
import { auth, addMagicToken, verifyMagicToken, getCountryCode } from "./auth";
import { userServiceCity, userServiceRegion, userSubVendorRegion } from "./UserServiceCity";
import { userChooseYourService, userUpdateChooseYourService } from "./UserChooseYourService";
import { locationDropdownReducer } from "./UserLocations";

import { addCompany, userCompanyDetails, userCompany, gstCompany, updateCompany, updateGstCompany, parentCompanyList } from "./company";
import userLogout from "./UserLogout";
// import { getRolesAndPermissions,getSupplierRole } from "./RolesAndPermissionsReducer";
import { getAdminUser, userAddAdminUser, userUpdateAdminUser } from "./AdminUserReducer";

const rootReducer = combineReducers({
  commonReducer: commonReducer,
  auth: auth,
  getCountryCode: getCountryCode,
  addCompany: addCompany,
  userCompany: userCompany,
  parentCompanyList: parentCompanyList,
  userCompanyDetails: userCompanyDetails,
  userServiceCity: userServiceCity,
  userServiceRegion: userServiceRegion,
  userSubVendorRegion: userSubVendorRegion,
  gstCompany:gstCompany,
  updateCompany:updateCompany,
  updateGstCompany:updateGstCompany,
  userChooseYourService:userChooseYourService,
  userUpdateChooseYourService:userUpdateChooseYourService,
  addMagicToken:addMagicToken,
  verifyMagicToken:verifyMagicToken,
  getAdminUser:getAdminUser,
  userUpdateAdminUser:userUpdateAdminUser,
  userAddAdminUser:userAddAdminUser,
  locationDropdown: locationDropdownReducer,
});

export default rootReducer;
